import axios from 'axios';
import {getToken} from './auth-service';

export function http() {
    return axios.create({
        baseURL: process.env.MIX_APP_API
    });
};

export function httpToken() {
    const token = getToken();
    return axios.create({
        baseURL: process.env.MIX_APP_API,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token.user.access_token}`
        }
    });
};

export function httpFile() {
    const token = getToken();
    return axios.create({
        baseURL: process.env.MIX_APP_API,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token.user.access_token}`
        }
    });
};
